import * as React from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { gtmTracking } from "@/utils/gtm-tracking"

const AffiliateHeader = ({
  title,
  primaryButtonText,
  secondaryButtonText,
  images,
}) => {
  return (
    <section className={`mt-20 pb-10`}>
      <div className="container-fluid">
        <div className="row middle-sm between-md center-xs start-sm">
          <div className="col-sm-6 col-md-6 mt-10 sm:mt-0 mb-10 sm:mb-0">
            <h1 className="h1--xl-condensed pb-8 pt-10 sm:pt-0 text-balance">
              {title}
            </h1>

            <div className="row start-sm center-xs">
              <a
                href="https://dash.partnerstack.com/application?company=capsule&group=affiliatepartnertriage"
                className="btn  btn--lg mr-6"
              >
                {primaryButtonText}
              </a>

              <a
                href="https://dash.partnerstack.com/"
                className="text-link"
                onClick={() =>
                  gtmTracking("Login Click", "Affiliate Dashboard", "")()
                }
              >
                {secondaryButtonText}
              </a>
            </div>
          </div>

          <div className="col-sm-5 col-sm-offset-1 mt-10 md:mt-0 affiliate-image-grid ">
            {images.map((image, index) => (
              <GatsbyImage
                key={index}
                image={getImage(image.src)}
                alt={image.alt}
                className="affiliate-image-grid__child"
                imgClassName="affiliate-image-grid__img"
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  )
}

export default AffiliateHeader
